/**
 * Veluna Quiz Routing Helper (TILE-05)
 * 
 * Provides consistent routing logic for quiz outcome pages
 * Handles redirect decisions and My Ritual URL generation
 */

(function() {
  'use strict';

  /**
   * Get My Ritual page URL
   * @returns {string} - My Ritual page URL
   */
  function getMyRitualUrl() {
    // Allow override via global variable
    if (window.VELUNA_MY_RITUAL_URL) {
      return window.VELUNA_MY_RITUAL_URL;
    }
    // Default URL
    return '/pages/my-ritual';
  }

  /**
   * Determine if user should be redirected to My Ritual page
   * @param {Object} options - Routing options
   * @param {string} options.currentPath - Current page path
   * @param {URLSearchParams} options.params - URL search params
   * @param {boolean} options.hasQuizState - Whether quiz state exists
   * @param {boolean} options.cameFromQuiz - Whether user came from quiz (URL param or sessionStorage)
   * @returns {{ shouldRedirect: boolean, reason: string }} - Redirect decision and reason
   */
  function shouldRedirectToMyRitual(options) {
    const { currentPath, params, hasQuizState, cameFromQuiz } = options;

    // Default: don't redirect
    let shouldRedirect = false;
    let reason = '';

    // Check if already on My Ritual page (prevent loops)
    const myRitualUrl = getMyRitualUrl();
    if (currentPath && currentPath.includes(myRitualUrl.replace(/^\//, ''))) {
      reason = 'Already on My Ritual page';
      return { shouldRedirect: false, reason };
    }

    // Rule 1: Must have quiz state
    if (!hasQuizState) {
      reason = 'No quiz state available';
      return { shouldRedirect: false, reason };
    }

    // Rule 2: Must have come from quiz (URL param or sessionStorage flag)
    if (!cameFromQuiz) {
      reason = 'User did not come from quiz (organic browsing)';
      return { shouldRedirect: false, reason };
    }

    // Rule 3: Must NOT have browse=true param
    if (params && params.get('browse') === 'true') {
      reason = 'User explicitly chose browse mode';
      return { shouldRedirect: false, reason };
    }

    // Rule 4: Must NOT have browse mode sessionStorage flag
    if (sessionStorage.getItem('veluna_browse_mode') === '1') {
      reason = 'User has browse mode session flag';
      return { shouldRedirect: false, reason };
    }

    // All conditions met - redirect
    shouldRedirect = true;
    reason = 'Quiz state exists, came from quiz, no browse override';
    return { shouldRedirect, reason };
  }

  // Expose API to window
  window.VelunaQuizRouting = {
    getMyRitualUrl: getMyRitualUrl,
    shouldRedirectToMyRitual: shouldRedirectToMyRitual
  };

})();

